import { useFeatureFlagEnabled } from '@posthog/react'

import { PartnerDetailsType } from '~/campaigns/types/campaign.types'
import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'
import { useGetUserLocationInfoFromIpQuery } from '~/redux/apis/geo-location-api'
import {
  BACK_TO_SCHOOL_2026_BY_GEO,
  BACK_TO_SCHOOL_2026_FLAG,
  BackToSchoolGeoOffer,
} from '~/shared/constants/backToSchoolPromo.const'

// Promo UI is limited to Norway and the US, the markets it is offered in.
const PROMO_COUNTRY_CODES: string[] = [
  CurriculumCountryCodes.NORWAY.toUpperCase(),
  CurriculumCountryCodes.USA.toUpperCase(),
]

// The PostHog flag and the country gate the promo; a partner that keeps it bypasses the flag, US visitors only.
export default function usePromoActive(partnerDetails?: PartnerDetailsType): boolean {
  const flagEnabled = !!useFeatureFlagEnabled(BACK_TO_SCHOOL_2026_FLAG)
  const { data: geoLocation } = useGetUserLocationInfoFromIpQuery()
  const countryCode = geoLocation?.countryCode

  if (partnerDetails?.keepsBackToSchool2026) return countryCode === CurriculumCountryCodes.USA.toUpperCase()
  return flagEnabled && Boolean(countryCode && PROMO_COUNTRY_CODES.includes(countryCode))
}

// The badge's discount and price follow the visitor's geo (IP country)
export function usePromoGeoOffer(): BackToSchoolGeoOffer | undefined {
  const { data: geoLocation } = useGetUserLocationInfoFromIpQuery()
  const geoCountryCode = geoLocation?.countryCode

  return geoCountryCode ? BACK_TO_SCHOOL_2026_BY_GEO[geoCountryCode] : undefined
}
